// @flow

import React, { Component, Fragment } from 'react';

import NextRencontreCard from 'containers/competitions/NextRencontreCardContainer';
import type { MatchType } from 'types/Competitions';


type Props = {
  rencontres: Array<MatchType>,
  equipeNom: string,
  competitionTitle: string,
};

export default class NextRencontresCard extends Component<Props> {
  renderNextRencontresCards = () => {
    const { rencontres, equipeNom, competitionTitle } = this.props;
    if (rencontres.length > 0) {
      return rencontres.map<any>((rencontre, index) => (
        <NextRencontreCard
          key={`Match_${equipeNom}-${rencontre.adversaire}_${rencontre.date_rencontre}`}
          equipeNom={equipeNom}
          competitionTitle={competitionTitle}
          isFirst={index === 0}
          rencontre={rencontre} />
      ));
    }
    return null;
  }

  render() {
    return (
      <Fragment>
        <h3 className="mb-3 mt-7">Matchs à venir</h3>
        {this.renderNextRencontresCards()}
      </Fragment>
    );
  }
}
